import { SnackSnsColor } from "@/lib/gql/__generated__/graphql";

import type { SnackBlocksFormModelMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods";
import type { SnackBlocksFormModelSNSMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/sns";

import { SNSColorSelect } from "./sns-color-select";

type Props = {
	snsColor: SnackBlocksFormModelSNSMethodsType["snsColor"];
	onSetSnackSnsColorToSNSColor: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetSnackSnsColorToSNSColor"];
};

export const SNSColorSelectSection = ({ snsColor, onSetSnackSnsColorToSNSColor }: Props) => {
	const selectedSnsColor = snsColor?.value;

	return (
		<div className="space-y-2">
			<p>SNSアイコンの色設定</p>
			<div className="ml-4 flex gap-x-6">
				<SNSColorSelect
					colorType={SnackSnsColor.White}
					selectedSnsColor={selectedSnsColor}
					onSetSnackSnsColorToSNSColor={onSetSnackSnsColorToSNSColor}
				/>

				<SNSColorSelect
					colorType={SnackSnsColor.Black}
					selectedSnsColor={selectedSnsColor}
					onSetSnackSnsColorToSNSColor={onSetSnackSnsColorToSNSColor}
				/>
			</div>
		</div>
	);
};

SNSColorSelectSection.displayName = "SNSColorSelectSection";
